// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:29:47

export default {
  "id": "bang-bang-mahjong",
  "slug": "bang-bang-mahjong",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/603eee6bcae742f880580aa8ffe1ec90-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/603eee6bcae742f880580aa8ffe1ec90/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bang Bang Mahjong",
      "description": "In Bang Bang Mahjong, we mix classic Mahjong with a sliding puzzle twist. It might seem simple at first, but as the levels get trickier, every move counts. Move the tiles around and match identical ones.\n\nPower-ups like shuffle, remove, or hints can help when things get tough. With each completed level, the challenge grows—but so does the satisfaction of solving it. Who can master every puzzle and clear the board like a pro?",
      "instructions": "Use the mouse or finger to move tiles around to align identical patterns, clearing them from the board.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "matching",
        "tiles"
      ]
    },
    "zh-CN": {
      "title": "砰砰麻将",
      "description": "在《Bang Bang麻将》中，我们将经典麻将与滑动拼图元素相结合。一开始可能看起来很简单，但随着关卡的难度增加，每个动作都至关重要。移动麻将牌，匹配相同的牌。\n\n当情况变得困难时，可以使用如洗牌、移除或提示等道具来帮助。每完成一个关卡，挑战都会增加——但解决问题的满足感也随之增长。谁能精通每一个谜题，像专业人士一样清空桌面呢？",
      "instructions": "使用鼠标或手指移动拼图，将相同图案对齐，从而清除它们从游戏板中。",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "匹配",
        "拼图"
      ]
    },
    "zh-TW": {
      "title": "砰砰麻將",
      "description": "在《砰砰麻將》中，我們將經典的麻將與滑動拼圖的變體結合。起初可能看起來很簡單，但隨著關卡變得越來越複雜，每一步都至關重要。移動 tile 並匹配相同的 tile。\n\n當情況變得棘手時，可以使用的 power-up 有洗牌、移除或提示等，以幫助解決困難。完成每個關卡後，挑戰性會不斷提升——但解決挑戰的滿足感也會隨之增長。誰能精通每個拼圖並像專家一樣清空棋盤呢？",
      "instructions": "使用滑鼠或手指移動圖片，將相同的圖案對齊，從遊戲板上消除它們。",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "配對",
        "磁磚"
      ]
    },
    "zh-HK": {
      "title": "砰砰麻將",
      "description": "在《砰砰麻將》中，我們將經典麻將與滑動拼圖元素結合。起初可能看似簡單，但隨著關卡難度增加，每一步都至關重要。移動磁片並匹配相同的圖案。\n\n當狀況變得棘手時，可以使用如洗牌、移除或提示等強化道具來幫助。完成每個關卡後，挑戰會越來越難，但解開的滿足感也會隨之增加。誰能掌握所有謎題，像專家一樣清空棋盤呢？",
      "instructions": "使用滑鼠或手指移動圖片，將相同圖案的圖片對齊，從遊戲版面上消除它們。",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "配對",
        "間諧"
      ]
    },
    "ja": {
      "title": "バンバン麻雀",
      "description": "バンバン麻雀で、古典的な麻雀をスライディングパズルの要素と組み合わせています。最初は簡単に見えるかもしれませんが、レベルが難しくなるにつれて、一つ一つの動きが大切になります。タイルを動かして同じものを合体させます。\n\nシャッフルや削除、ヒントなどのパワーアップは困難な時支えてくれます。レベルをクリアするたびに、挑戦が高まり、解決の達成感も大きくなります。どれだけのパズルをマスターし、プロのようにボードをクリアできるのか？",
      "instructions": "マウスや指でタイルを動かし、同じパターンを整え、ボードから消去します。",
      "genres": [
        "麻雀 & コネクト"
      ],
      "tags": [
        "マッチング",
        "タイル"
      ]
    },
    "ko": {
      "title": "밤밤 매충",
      "description": "뱅뱅마주공에서는 클래식 마주공을 슬라이딩 퍼즐 요소와 결합했습니다. 처음 보면 간단하게 보일 수 있지만, 레벨이 어려워질수록 각 이동이 중요합니다. 타일을 이동시키고 동일한 타일을 매칭하세요.\n\n시끄럽게 되었을 때, 섞기, 제거, 팁과 같은 파워업이 도움이 될 수 있습니다. 각 완료된 레벨마다 도전이 증가하지만, 해결하는 만족도도 증가합니다. 누가 모든 퍼즐을 마스터하고 전문가처럼 보드를 클리어할 수 있을까요?",
      "instructions": "마우스나 손가락으로 타일을 이동하여 같은 패턴을 맞추어 보드에서 제거합니다.",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "매칭",
        "타일"
      ]
    },
    "fr": {
      "title": "Bang Bang Mahjong",
      "description": "Dans Bang Bang Mahjong, nous mélangeons le Mahjong classique avec un twist de puzzle glissant. Au début, cela peut sembler simple, mais à mesure que les niveaux deviennent plus difficiles, chaque déplacement compte. Déplacez les tuiles et matchez les identiques.\n\nDes pouvoirs comme le mélange, l'élimination ou les indices peuvent aider lorsque les choses deviennent difficiles. Avec chaque niveau terminé, le défi augmente, mais ainsi aussi la satisfaction de le résoudre. Qui peut maîtriser chaque puzzle et nettoyer le plateau comme un professionnel ?",
      "instructions": "Utilisez la souris ou l'index pour déplacer les tuiles pour aligner des motifs identiques, en les enlevant du plateau.",
      "genres": [
        "Mahjong et Connexion"
      ],
      "tags": [
        "matching",
        "tuiles"
      ]
    }
  }
};
